import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowBack } from '@mui/icons-material'
import { Box, Button, ButtonBase, Dialog, DialogContent, Grid, Stack, Typography } from '@mui/material'

import GRDialogTitle from '../../../../../components/GRDialogTitle/GRDialogTitle'
import { borderRadiusDefault } from '../../../../../themes/theme'
import { InternalGameScreenshot } from '../../../../api/screenshot-links'

type FeatureImplementationsDialogProps = {
  open: boolean
  gameName: string
  featureName: string
  screenshots: InternalGameScreenshot[]
  onClose: () => void
}

export const FeatureImplementationsDialog: FC<FeatureImplementationsDialogProps> = ({ open, gameName, featureName, screenshots, onClose }) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState<InternalGameScreenshot>()

  useEffect(() => {
    if (!open) setSelected(undefined)
  }, [open])

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <GRDialogTitle onClose={onClose}>
        <Box minWidth={0}>
          {t('internal-analysts:analysis_implementations_title', { name: gameName })}
          <Typography variant="body2" color="text.secondary">
            {t('internal-analysts:analysis_implementations_feature', { name: featureName })}
          </Typography>
        </Box>
      </GRDialogTitle>
      <DialogContent>
        {selected ? (
          <Stack spacing={2} alignItems="center">
            <Box component="img" src={selected.url} alt={selected.gameVersion ?? ''} sx={{ maxWidth: '100%', maxHeight: '70vh' }} />
            <Button startIcon={<ArrowBack />} onClick={() => setSelected(undefined)}>
              {t('internal-common:back')}
            </Button>
          </Stack>
        ) : (
          <Grid container spacing={2}>
            {screenshots.map((screenshot, index) => (
              <Grid item xs={6} sm={4} md={3} key={screenshot.id}>
                <ButtonBase
                  aria-label={t('internal-analysts:analysis_implementations_screenshot', { index: index + 1 })}
                  onClick={() => setSelected(screenshot)}
                  sx={{ width: '100%', flexDirection: 'column', alignItems: 'stretch', borderRadius: borderRadiusDefault, overflow: 'hidden' }}
                >
                  <Box component="img" src={screenshot.url} alt="" loading="lazy" sx={{ width: '100%', display: 'block' }} />
                  <Typography variant="caption" color="text.secondary" textAlign="center" py={0.5}>
                    {screenshot.gameVersion ?? '-'}
                  </Typography>
                </ButtonBase>
              </Grid>
            ))}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  )
}
